import { get } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'

// export const getContentBaseurl = meta => get(meta, API_CONSTANTS.META.PATHS.CONTENT_BASEURL)
export const getContentBaseurl = meta => {
  return get(meta, API_CONSTANTS.AIMEOS.META.PATHS.CONTENT_BASEURL)
}
